
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {function()}func
 * @param {number} wait
 * @returns {function()}
 */
export function debounce(func, wait) {
  let timeout;

  return function () {
    const context = this;
    const args = arguments;

    // 如果之前的定时器还存在，则清除它  
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }

    // 设置一个新的定时器，在wait毫秒后执行func  
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}


/**
 * @param {number} value
 * @returns {string}
 */
export function formatDate(value) {// 时间戳转换日期格式方法

  if (value == null) {
    return '';
  } else {
    let date = new Date(value);
    let y = date.getFullYear();// 年
    let MM = date.getMonth() + 1;// 月
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();// 日
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + MM + '-' + d
  }
}


/**
 * @param {number} value
 * @returns {string}
 */
export function formatDateTime(value) {// 时间戳转换日期格式方法

  if (value == null) {
    return '';
  } else {
    let date = new Date(value);
    let y = date.getFullYear();// 年
    let MM = date.getMonth() + 1;// 月
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();// 日
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();// 时
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();// 分
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();// 秒
    s = s < 10 ? ('0' + s) : s;

    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  }
}


export function formatAddress(data) {
  let address = '';
  // 检查province和city的text是否相同  
  if (data.province.split(',')[0] !== data.city.split(',')[0]) {
    // 如果不同，则拼接province  
    address += data.province.split(',')[0] + ' ';
  }

  // 总是拼接city  
  address += data.city.split(',')[0] + ' ';

  // 拼接district  
  address += data.district.split(',')[0] + ' ';

  // 拼接address  
  address += data.address;

  return address.trim(); // 去除尾部可能的多余空格  
}

export function base64ImgtoFile(dataurl, filename = 'file') {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
}

export function containsValue(str, value) {
  if (str === '*') return true
  // 将字符串按逗号分割成数组  
  const valuesArray = str.split(',');
  // 检查数组中是否包含指定的值  
  return valuesArray.includes(value);
}  